var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMenuItemTag = function SvgIconMenuItemTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.874 12.293-6.572 6.573a1.833 1.833 0 0 1-2.594 0L1.833 11V1.834H11l7.874 7.874c.711.715.711 1.87 0 2.585",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.792,
    cy: 7.791,
    r: 1.375,
    fill: "currentColor"
  })));
};
export { SvgIconMenuItemTag as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC44NzQgMTIuMjkzbC02LjU3MiA2LjU3M2ExLjgzMyAxLjgzMyAwIDAxLTIuNTk0IDBMMS44MzMgMTFWMS44MzRIMTFsNy44NzQgNy44NzRjLjcxMS43MTUuNzExIDEuODcgMCAyLjU4NXoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48Y2lyY2xlIGN4PSI3Ljc5MiIgY3k9IjcuNzkxIiByPSIxLjM3NSIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";